import { render, staticRenderFns } from "./MhStudiosPromoRejectedModal.vue?vue&type=template&id=0d172548&scoped=true"
import script from "./MhStudiosPromoRejectedModal.vue?vue&type=script&lang=js"
export * from "./MhStudiosPromoRejectedModal.vue?vue&type=script&lang=js"
import style0 from "./MhStudiosPromoRejectedModal.vue?vue&type=style&index=0&id=0d172548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d172548",
  null
  
)

export default component.exports